import { combineReducers } from 'redux'

import carAluminiumRim from './CarAluminiumRimSearch/carAluminiumRimSearchSlice'

export default combineReducers({
	carAluminiumRim,
})